import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import Header from '../components/Header';
import SongPortal from '../components/SongPortal';

export default function DjPortalPage() {
  const navigate = useNavigate();
  const [room, setRoom] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.djGetRoom()
      .then(setRoom)
      .catch(() => {
        api.clearSession();
        navigate('/login?role=dj');
      });
  }, [navigate]);

  if (!room) {
    return (
      <div className="app-shell">
        <Header />
        <div className="loading-screen"><div className="spinner lg" /><span>Загружаем комнату...</span></div>
      </div>
    );
  }

  return (
    <div className="app-shell">
      <Header roomCode={room.code} subtitle={room.name} />
      {error && <div className="container"><div className="alert alert-error" style={{marginTop:12}}>{error}</div></div>}
      <SongPortal roomCode={room.code} isDj={true} />
    </div>
  );
}
